import { gunterzBold } from '@/theme/fonts';
import { useLingui } from '@lingui/react';
import { Card, Grid, Title } from '@mantine/core';
import { ReferralMetric } from './ReferralMetric';
import { ReferralMissionCard } from './ReferralMissionCard';
import { ReferralTable } from './ReferralTable';
export const ReferralLayout: React.FC = () => {
  const {
    i18n
  } = useLingui();
  return <Grid mt={{
    base: 8,
    sm: 10
  }} gutter={{
    base: 16,
    sm: 20
  }}>
      <Grid.Col span={{
      base: 12,
      lg: 8
    }}>
        <Grid gutter={{
        base: 16,
        sm: 20
      }} grow>
          <Grid.Col span={6}>
            <ReferralMetric title={i18n._('total referrals')} metricValue={125} />
          </Grid.Col>
          <Grid.Col span={6}>
            <ReferralMetric title={i18n._('total earned')} metricValue={250} suffix=" PRLL" />
          </Grid.Col>
          <Grid.Col span={6}>
            <ReferralMetric title={i18n._('This moth referrals')} metricValue={32} />
          </Grid.Col>
          <Grid.Col span={6}>
            <ReferralMetric title={i18n._('race ranking')} metricValue={3} />
          </Grid.Col>
          <Grid.Col span={6}>
            <Card radius={5} bg="var(--navbar-bg-color)">
              <Title fz={{
              base: 14,
              sm: 18
            }} className={gunterzBold.className}>
                {i18n._('race leaderboard')}
              </Title>

              <ReferralTable />
            </Card>
          </Grid.Col>
        </Grid>
      </Grid.Col>

      <Grid.Col span={{
      base: 12,
      lg: 4
    }}>
        <ReferralMissionCard />
      </Grid.Col>
    </Grid>;
};